<template>
  <div style="
  
	width:1200px;
	margin:0 auto 20px;
  display: block;
  ">
  <div class="breadBox">
    <a-breadcrumb>
      <span>
        <img src="@/assets/img/position.png"/>
        当前位置：
      </span>
      <a-breadcrumb-item style="cursor: pointer;" @click="$router.push({ path: '/knowledge/index'})">首页</a-breadcrumb-item>
      <a-breadcrumb-item>知识产权转让</a-breadcrumb-item>
    </a-breadcrumb>
  </div>
  <div class="cont_body">
    <div class="body_img">
      <img src="../../../img/jyzr.jpg" />
    </div>
    <div class="body_cont">
      <div v-for="(item,key) in dataSource" :key="key" class="list_cont flex-cl" @click="goMore('/knowledge/institution/page','知识产权机构',item.id)">
        <div class="img_cont">
          <div class="img">
            <img v-if="item.thumbnail" :src="getImg(item.thumbnail)" alt="">
            <img v-else src="@/assets/img/defaultPhoto.png" alt="">
          </div>
          <div class="img_right">
            <h3>{{item.title}}</h3>
          </div>
        </div>
        <!-- <p>联系人：{{item.contacts}}</p>
        <p>地址：{{item.workAddress	}}</p> -->
      </div>
    </div>
  </div>
  <!--分页-->
  <div class="pagination">
    <a-pagination v-model="current" :total="total" :page-size="pageSize" showQuickJumper @change="onChange" />
  </div>
</div>
</template>
<script>
import { listMixin } from "@/mixins";
import { basicsEssayInfoweb } from "@/api/finance";
import {file_service} from "@/api/adminService";
export default {
  name: 'investor',
  components: { 
    // DictRender
   },
  mixins: [listMixin],
  props: {
    title: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      listUrl: basicsEssayInfoweb.pageList,
      queryParamFixed: { 
          systemType: 'knowledge',
          type:'l',
          pageNum: 1,
          pageSize: 10,
       },
      current: 1,
      pageSize: 10,
    }
  },
  mounted() {
  },
	methods: {
    getImg(imgUrl) {
        return file_service.imagesWeb(imgUrl)
    },
		goMore(url,key,id) {
			this.$router.push({path: url, query: {type: key,queryData: id}})
		},
		backhome() {
      this.goMore('/knowledge/index')
      // location.reload()
		}
	}
}
</script>
<style scoped lang="less">
@import "../../../css/components.less";
.list_cont{
  width: 492px;
  margin-right:16px;
  margin-bottom:16px;
  padding: 25px 15px;
  &:nth-child(2n){
    margin-right: 0;
  }
  .img_cont{
    display: flex;
    width: 100%;
    .img_right{
      flex: 1;
      p{
        color:#cccccc;
        text-align: left;
        word-break: break-all;
        overflow:hidden; 
        text-overflow:ellipsis; 
        display:-webkit-box;
        -webkit-box-orient:vertical;  
        -webkit-line-clamp:3;
      }
    }
  }
  .img{
    border:1px solid #eeeeee;
    width: 100px;
    height:100px;
    margin-right: 16px;
    display: flex;
    align-items: center;
    img{
      width: 100%;
    }
  }
  h3{
    font-size: 20px;
    text-align: left;
    word-break: break-all;
    overflow:hidden; 
    text-overflow:ellipsis; 
    display:-webkit-box;
    -webkit-box-orient:vertical;  
    -webkit-line-clamp:1;
  }
  p{
    width: 100%;
    font-size: 16px;
    text-align: left;
    word-break: break-all;
    overflow:hidden; 
    text-overflow:ellipsis; 
    display:-webkit-box;
    -webkit-box-orient:vertical;  
    -webkit-line-clamp:1;
  }
  .text{
    width:100%;
    height: 75px;
    text-align: left;
    word-break: break-all;
    overflow:hidden; 
    text-overflow:ellipsis; 
    display:-webkit-box;
    -webkit-box-orient:vertical;  
    -webkit-line-clamp:3;
  }
  .tag{
    text-align: left;
    margin-top: 25px;
    width: 100%;
    color:#cccccc;
  }

}
</style>